module.exports = __webpack_public_path__ + "static/media/salesforce.ef017bea.png";